<template>
    <div class="project-type-development">

        <div class="row">
            <div class="col-lg-6">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="projects.coverageDevelopment" />
                        Udviklingen i DB pr. opgavetype
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectProjectType"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field == 'progress_percent'" style="text-align:left;">
                                    <span v-if="props.row.progress_percent >= 5" class="color-good">
                                        <i class="fas fa-arrow-up" />
                                        <!--+{{ props.row.progress_percent }} %-->
                                    </span>
                                    <span v-else-if="props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5">
                                        <i class="fas fa-arrow-right color-avg" />
                                        <!--{{ props.row.progress_percent }} %-->
                                    </span>
                                    <span v-else class="color-bad">
                                        <i class="fas fa-arrow-down" />
                                        <!--{{ props.row.progress_percent }} %-->
                                    </span>
                                </div>
                                <div v-else-if="props.column.field == 'coverage_avg'" style="text-align:left;">
                                    {{ props.row.coverage_avg | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'projects_count'" style="text-align:left;">
                                    {{ props.row.projects_count | number }}
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name ? props.row.name : '-'">
                                    {{ props.row.name ? props.row.name : '-' }}
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>

            <div class="col-lg-6">

                <div class="placeholder fit-content" v-if="!loading && series.length > 0">
                    <div class="placeholder__heading">
                        {{ series[0].name }}
                    </div>
                    <div class="placeholder padding">
                        <vue-apex-charts
                            ref="tester"
                            :height="height"
                            :options="options"
                            :series="series"
                            v-if="!loading && series.length > 0"
                            type="line"
                        />
                    </div>
                </div>

                <div v-else>
                    Vælg en opgavetype for at se fremgangen i en graf
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import * as projectTypeService from '@/services/projectTypeService'
import VueApexCharts from 'vue-apexcharts'

export default {
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Opgavetype', field: 'name', type: 'string' },
                { label: 'Antal', field: 'projects_count', type: 'number' },
                { label: 'DB (sum)', field: 'coverage_avg', type: 'number' },
                { label: 'Udvikling', field: 'progress_percent', type: 'number' }
            ],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_avg',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            },
            height: '450',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value > 0) {
                                return this.$options.filters.currency(value)
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    /* showForSingleSeries: false,
                    showForNullSeries: false,
                    showForZeroSeries: false, */
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.series = []
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            projectTypeService.development(params, (response) => {
                this.options.labels = response.data.labels
                this.rows = response.data.values
                // this.series = response.data.values
                this.loading = false
                this.$emit('finishedLoading', response.data.values.length)
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectProjectType (params) {
            this.series = []
            this.series.push(params.row)
        },
        selectedRowClass (row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected'
            }
        }
    },
    components: {
        VueApexCharts
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// projectTypeDevelopment.vue?6074ab1c